import React from 'react';
import { Server, Image } from '../../../Cloud.model';
import { getFullPriceLabel } from './ImagePrice.service';

export interface UHCImagePriceProps {
    image:Image,
    server?:Server
}

const UHCImagePrice: React.FC<UHCImagePriceProps> = (props:UHCImagePriceProps) => {
    const price = getFullPriceLabel(props.image, (props.server)?props.server.plan.billingType:null);

    return (
        <>
            {price}
        </>
    );
};

export default UHCImagePrice;
